/**
 * Builds HTML content for map marker popups
 * Separating this logic makes it easier to maintain and test
 */

/**
 * Creates the popup HTML for a marker
 * @param {Object} info - The marker information object
 * @returns {string} HTML string for the popup content
 */
export function buildMarkerPopup(info) {
    const parts = [];

    // Add image if present
    if (info.image) {
        parts.push(`<img src="${info.image}" alt="${escapeHtml(info.title)}" loading="lazy" />`);
    }

    // Start content wrapper
    parts.push('<div class="p-2">');

    // Add title (always present)
    parts.push(`<h2 class='text-2p4 border-b border-solid pb-1 mb-1'>${info.title}</h2>`);

    // Start details section
    parts.push('<div class="text-1p4">');

    // Define fields in order with their CSS classes
    const fields = [
        { key: 'artist', class: '!mt-0 !mb-p5 font-bold' },
        { key: 'date', class: '!mt-0 !mb-p5' },
        { key: 'medium', class: '!mt-0 !mb-p5' },
        { key: 'dimensions', class: '!mt-0 !mb-p5' },
        { key: 'description', class: '!mt-0 !mb-p5' },
        { key: 'note', class: '!mt-0 !mb-p5 text-1' }
    ];

    // Add each field if it exists
    fields.forEach(field => {
        if (info[field.key]) {
            parts.push(`<p class="${field.class}">${info[field.key]}</p>`);
        }
    });

    // Add link if present
    if (info.link) {
        const linkText = info.linkText || 'Learn More';
        parts.push(`<a class="map-link" href="${info.link}">${linkText}</a>`);
    }

    // Close wrappers
    parts.push('</div>'); // Close text-1p4
    parts.push('</div>'); // Close p-2

    return parts.join('');
}

/**
 * Simple HTML escape utility to prevent XSS
 * Only used for alt text where user input might be involved
 * @param {string} text - Text to escape
 * @returns {string} Escaped text
 */
function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

export default buildMarkerPopup;
